<div class="email-input-container" [formGroup]="form">
  <input
    placeholder="E-Mail Adresse eingeben"
    type="email"
    [name]="name()"
    [formControlName]="controlName()"
    [value]="control().value"
    [class.error]="errorMessage()"
    [attr.aria-required]="true"
    [attr.aria-labelledby]="labelledBy()"
    [autocomplete]="AutocompleteValue.EMAIL"
  />
  @if (errorMessage(); as _message) {
    <span class="error-message">{{ _message }}</span>
  }
</div>
